import React from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import {
  FileDrop,
  FileUploads,
  FileDownloads
} from 'components/form/prototypes';

const FileAttachments = () => {

  return (
    <>
      <Row className={'mb-4'}>
        <Col>
          <Row className={'mb-2'}>
            <Col>
              <h5>File Attachments<hr /></h5>
            </Col>
          </Row>
          <Row className={'mb-2'}>
            <Col>
              <FileDrop />
            </Col>
          </Row>
          <Row className={'mb-2'}>
            <Col md>
              <FileUploads />
            </Col>
            <Col md>
              <FileDownloads />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export { FileAttachments };
